// eventColors.js
const eventColors = {
    Home: '#1E90FF',         // Blue
    Away: '#FF4500',         // Orange
    'Home & Away': '#28a745' // Green
};

export default eventColors;
